const FaIcon = require('./fa-icon');
const Icon = require('./Icon');

module.exports = {
  Icon,
  FaIcon,
};
